(function(){
  function clamp(v,a,b){return Math.max(a,Math.min(b,v));}

  /* nav solidify */
  var nav=document.querySelector('[data-nav]');
  function onNav(){ if(window.scrollY>40){nav.classList.add('solid');}else{nav.classList.remove('solid');} }
  window.addEventListener('scroll',onNav,{passive:true}); onNav();

  /* mobile menu toggle */
  var navToggle=document.querySelector('[data-nav-toggle]');
  if(nav && navToggle){
    navToggle.addEventListener('click',function(){
      var open=nav.classList.toggle('nav--open');
      navToggle.setAttribute('aria-expanded',open?'true':'false');
    });
    nav.querySelectorAll('.nav__link').forEach(function(l){
      l.addEventListener('click',function(){ nav.classList.remove('nav--open'); navToggle.setAttribute('aria-expanded','false'); });
    });
  }

  /* reveal on scroll */
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);} });
  },{threshold:.16,rootMargin:'0px 0px -8% 0px'});
  document.querySelectorAll('.reveal').forEach(function(el){io.observe(el);});

  /* faq */
  document.querySelectorAll('[data-faq] .faq__item').forEach(function(item){
    item.querySelector('.faq__q').addEventListener('click',function(){ item.classList.toggle('open'); });
  });

  /* ---------- persistent pan stage ---------- */
  var stage=document.querySelector('[data-stage]');
  var canvas=document.querySelector('[data-scroll-hero-canvas]');
  var dimEl=document.querySelector('[data-stage-dim]');
  var overlay=document.querySelector('[data-hero-overlay]');
  var cue=document.querySelector('[data-hero-cue]');
  var panEnd=document.querySelector('[data-pan-end]');
  var dataEl=document.querySelector('[data-scroll-hero-frames]');
  var urls; try{urls=JSON.parse(dataEl.textContent);}catch(e){urls=[];}

  if(canvas && urls.length){
    var ctx=canvas.getContext('2d');
    ctx.imageSmoothingEnabled=true; ctx.imageSmoothingQuality='high';
    var images=new Array(urls.length);
    var currentIndex=-1;
    var dpr=Math.min(window.devicePixelRatio||1,2);

    function resize(){
      /* square canvas sized to the viewport diagonal so a 45deg tilt never exposes an edge */
      var side=Math.ceil(Math.hypot(stage.clientWidth,stage.clientHeight));
      var px=Math.round(side*dpr);
      if(px>0 && px!==canvas.width){canvas.width=px;canvas.height=px;}
      canvas.style.width=side+'px'; canvas.style.height=side+'px';
      draw(currentIndex<0?0:currentIndex,true);
    }
    function draw(index,force){
      if(index===currentIndex && force!==true) return;
      var img=images[index];
      if(!img || img.complete!==true || img.naturalWidth===0) return;
      currentIndex=index;
      var cw=canvas.width, ch=canvas.height;
      ctx.clearRect(0,0,cw,ch);
      /* size the pan off the viewport's shorter side, not the oversized square canvas */
      var vmin=Math.min(stage.clientWidth,stage.clientHeight)*dpr;
      var scale=(vmin/img.naturalWidth)*2.30;
      var dw=img.naturalWidth*scale, dh=img.naturalHeight*scale;
      ctx.drawImage(img,(cw-dw)/2,(ch-dh)/2+vmin*0.08,dw,dh);
    }
    function panGone(){
      var top=panEnd.getBoundingClientRect().top + window.scrollY;
      return Math.max(top - window.innerHeight*0.6, 1);
    }
    var ticking=false;
    function onScroll(){
      if(ticking) return; ticking=true;
      requestAnimationFrame(function(){
        var y=window.scrollY, vh=window.innerHeight, end=panGone();
        var fp=clamp(y/end,0,1);
        draw(Math.round(fp*(urls.length-1)));
        /* dim: 34% baseline at rest (pan more visible), smoothstep fade up to ~78% by the handoff (20% brighter both ends) */
        var p=clamp(y/end,0,1);
        var d=0.34+(p*p*(3-2*p))*0.44;
        dimEl.style.opacity=String(d);
        if(overlay) overlay.style.opacity=String(clamp(1 - y/(vh*0.7),0,1));
        if(cue) cue.style.opacity=String(clamp(1 - y/(vh*0.4),0,1));
        ticking=false;
      });
    }
    urls.forEach(function(url,i){
      var img=new Image();
      img.onload=function(){ if(i===0)resize(); if(i===currentIndex)draw(i,true); };
      img.src=url; images[i]=img;
    });
    window.addEventListener('scroll',onScroll,{passive:true});
    window.addEventListener('resize',resize);
    resize(); onScroll();
    if(window.ResizeObserver){ new ResizeObserver(function(){resize();onScroll();}).observe(stage); }
    window.addEventListener('load',function(){resize();onScroll();});
  }
})();